"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _reactFiles = _interopRequireDefault(require("react-files"));

var _When = _interopRequireDefault(require("../../../../../../../common/components/When"));

require("../styles/_asset-selection.scss");

var _Clips = _interopRequireDefault(require("./Clips"));

var _lodash2 = _interopRequireDefault(require("lodash.memoize"));

var _utils = require("../../../../../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function EmptyFileZone(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "files-dropzone"
  }, children);
}

function onUpdateLabelsForAsset(assetId, assignedLabels, updateProject) {
  return function (assetId) {
    return function (labelIds) {
      var newLabels = _objectSpread(_objectSpread({}, assignedLabels), {}, _defineProperty({}, assetId, labelIds));

      updateProject({
        assignedLabels: newLabels
      }, {
        override: true
      });
    };
  };
}

var AssetSelection = /*#__PURE__*/function (_Component) {
  _inherits(AssetSelection, _Component);

  var _super = _createSuper(AssetSelection);

  function AssetSelection() {
    var _this;

    _classCallCheck(this, AssetSelection);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onChangeClipIndex", (0, _lodash2.default)(function (clipId) {
      return function (index) {
        var _this$props = _this.props,
            onUpdateVideoClips = _this$props.onUpdateVideoClips,
            clips = _this$props.clips;

        var newClips = _toConsumableArray(clips);

        var clipIndex = clips.findIndex(function (clip) {
          return clip.clipId === clipId;
        });
        var clip = newClips[clipIndex];
        newClips.splice(clipIndex, 1);
        newClips.splice(index, 0, clip);
        onUpdateVideoClips((0, _utils.setClipsStartTimesOnIndex)(newClips));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "setFileDropIndex", (0, _lodash.default)(function (index) {
      _this.setState({
        fileDropIndex: index
      });
    }, 100));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (files) {
      var onSelectFiles = _this.props.onSelectFiles;
      var fileDropIndex = _this.state.fileDropIndex;

      if (!files.length) {
        return;
      }

      onSelectFiles(files, fileDropIndex);

      _this.setState({
        fileDropIndex: void 0
      });

      _this._filesRef.removeFiles();

      var scrollableAssets = document.querySelector('.asset-selection__assets');

      if (!scrollableAssets) {
        return;
      }

      scrollableAssets.scrollTo({
        top: scrollableAssets.scrollHeight,
        behavior: 'smooth'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "viewAssetDetails", function (assetId) {
      return function () {
        _this.setState({
          assetDetailsId: assetId
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "closeDetailsModal", function () {
      _this.setState({
        assetDetailsId: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setFilesRef", function (el) {
      _this._filesRef = el;
    });

    _defineProperty(_assertThisInitialized(_this), "onBrowseFiles", function () {
      if (!_this._filesRef) {
        return;
      }

      _this._filesRef.openFileChooser();
    });

    _this.state = {};
    return _this;
  }

  _createClass(AssetSelection, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          visibleAssetIds = _this$props2.visibleAssetIds,
          selectedAssets = _this$props2.selectedAssets,
          onSelectAsset = _this$props2.onSelectAsset,
          apolloClient = _this$props2.apolloClient,
          updateProject = _this$props2.updateProject,
          labels = _this$props2.labels,
          assignedLabels = _this$props2.assignedLabels,
          onRemoveAssets = _this$props2.onRemoveAssets,
          toggleSourceFiles = _this$props2.toggleSourceFiles,
          canUpdateVideo = _this$props2.canUpdateVideo,
          hasArchiveAssetsPermission = _this$props2.hasArchiveAssetsPermission,
          hasDeleteAssetsPermission = _this$props2.hasDeleteAssetsPermission,
          onArchiveAsset = _this$props2.onArchiveAsset,
          onDeleteAsset = _this$props2.onDeleteAsset,
          onSaveAssetDetails = _this$props2.onSaveAssetDetails,
          videoName = _this$props2.videoName,
          hasCommentPermission = _this$props2.hasCommentPermission,
          clips = _this$props2.clips,
          onAddComments = _this$props2.onAddComments;
      var _this$state = this.state,
          assetDetailsId = _this$state.assetDetailsId,
          fileDropIndex = _this$state.fileDropIndex;
      var FilesComponent = canUpdateVideo ? _reactFiles.default : EmptyFileZone;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "asset-selection column"
      }, /*#__PURE__*/_react.default.createElement(_commonReact.ManageAssetModal, {
        assetId: assetDetailsId,
        apiClient: apolloClient,
        isVisible: Boolean(assetDetailsId),
        onClose: this.closeDetailsModal,
        onSave: onSaveAssetDetails
      }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(FilesComponent, {
        ref: this.setFilesRef,
        onChange: this.onChange,
        minFileSize: 1,
        clickable: false,
        dropActiveClassName: fileDropIndex === void 0 ? 'asset-selection--dragging' : ''
      }, /*#__PURE__*/_react.default.createElement(_When.default, {
        isTruthy: !clips.length
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "asset-selection__empty"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: "importI",
        color: "regent",
        size: 70
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading3: true
      }, "Drag and drop your assets here"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        subtitle: true
      }, "or use the options below"), /*#__PURE__*/_react.default.createElement("div", {
        className: "asset-selection__empty__buttons"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        type: "TERTIARY",
        onClick: this.onBrowseFiles,
        prefix: "folder"
      }, "My Device"), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        type: "TERTIARY",
        onClick: toggleSourceFiles,
        prefix: "medialibrary"
      }, "Media Library")))), /*#__PURE__*/_react.default.createElement("div", {
        className: "asset-selection__drag"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        label: true,
        noMargin: true
      }, "Drop files here to upload them to"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading5: true,
        noMargin: true
      }, videoName)), /*#__PURE__*/_react.default.createElement(_When.default, {
        isTruthy: clips.length
      }, /*#__PURE__*/_react.default.createElement(_Clips.default, {
        onChangeClipIndex: this.onChangeClipIndex,
        clips: clips.filter(function (clip) {
          return visibleAssetIds.some(function (assetId) {
            return assetId === clip.assetId;
          });
        }),
        onSelectAsset: onSelectAsset,
        selectedAssets: selectedAssets,
        onUpdateLabelsForAsset: onUpdateLabelsForAsset(assignedLabels, updateProject),
        assignedLabels: assignedLabels,
        labels: labels,
        onRemoveAssets: onRemoveAssets,
        viewAssetDetails: this.viewAssetDetails,
        canUpdateVideo: canUpdateVideo,
        hasArchiveAssetsPermission: hasArchiveAssetsPermission,
        hasDeleteAssetsPermission: hasDeleteAssetsPermission,
        onArchiveAsset: onArchiveAsset,
        onDeleteAsset: onDeleteAsset,
        hasCommentPermission: hasCommentPermission,
        onAddComments: onAddComments,
        setFileDropIndex: this.setFileDropIndex,
        toggleSourceFiles: toggleSourceFiles,
        onBrowseFiles: this.onBrowseFiles
      })))));
    }
  }]);

  return AssetSelection;
}(_react.Component);

exports.default = AssetSelection;